import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { isValidPhoneNumber } from "libphonenumber-js";
import PhoneInput from "react-phone-input-2";
const PhoneCountryCodeInput = ({ form, value, onChange, }) => {
    return (_jsx(_Fragment, { children: _jsx(PhoneInput, { specialLabel: "",
            // country={"us"} // You can set the default country
            value: value, onChange: onChange, inputStyle: { width: "100%" } }) }));
};
export default PhoneCountryCodeInput;
export const validatePhoneNumber = (_, value) => {
    if (!value) {
        return Promise.resolve();
        // return Promise.reject(new Error("Please enter a valid phone number"));
    }
    // Use libphonenumber-js to check for a valid phone number
    if (isValidPhoneNumber(`+${value}`)) {
        return Promise.resolve();
    }
    else {
        return Promise.reject(new Error("Invalid phone number format"));
    }
};
